import { Routes } from '@angular/router';
import { authGuard } from '../guards/auth.guard';
import { clientIdGuard } from '../guards/client-id/client-id.guard';

export const fdIdRoutes: Routes = [
  {
    path: 'fdid',
    canActivate: [authGuard, clientIdGuard],
    loadComponent: () =>
      import('../components/fdid/fdid.component').then(
        (m) => m.FdidComponent
      ),
    children: [
      {
        path: 'graphs',
        loadComponent: () =>
          import('../components/fdid/graphs/graphs.component').then(
            (m) => m.GraphsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'fdid-warnings',
        loadComponent: () =>
          import('../components/fdid/warnings/warnings.component').then(
            (m) => m.FdIdWarningsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'sessions',
        loadComponent: () =>
          import('../components/fdid/sessions/sessions.component').then(
            (m) => m.SessionsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../components/fdid/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
        {
        path: 'fdid-warnings-settings',
        loadComponent: () =>
          import('../components/fdid/warnings-settings/warnings-settings.component').then(
            (m) => m.WarningsSettingsComponent
          ),
        canActivate: [authGuard, clientIdGuard],
      },
    ],
  },
];
